import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "catalogue");

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "694yfr_5Ul",
        width: 334.19,
        height: 56.734375,
        left: 127.85,
        top: 394.18,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
        content:
          '<p style="text-align: right;"><span style="font-size: 36.73px;font-family: 微软雅黑;letter-spacing: 12.244897959183675px;">CONTENTS</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "Gy5b2ZEUV0",
        width: 334.19,
        height: 56.734375,
        left: 127.85,
        top: 333.01,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
        content:
          '<p style="text-align: right;"><span style="font-size: 36.73px;font-family: 微软雅黑;letter-spacing: 12.244897959183675px;">目录</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "eV07PXbNe_",
        width: 5.91,
        height: 134.52,
        left: 499.07,
        top: 305.65,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "#c00000",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#600000",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 微软雅黑;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "WQFFuzUuBn",
        width: 5.91,
        height: 70.87,
        left: 116.58,
        top: 369.31,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "#c00000",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#600000",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 微软雅黑;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 568.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
      },
    ],

    background,
  };
}
